<h1>Reports</h1>

<p-card header="Report Categories">
  <ul class="categories">
    <li *ngIf="canSeeReportCategory('Accounting') | async">
      <a routerLink="/accounting">Accounting Reports</a>
    </li>
    <li *ngIf="canSeeReportCategory('Customer') | async">
      <a routerLink="/customer">Customer Reports</a>
    </li>
    <li *ngIf="canSeeReportCategory('EndOfShift') | async">
      <a routerLink="/end-of-shift">End of Shift Reports</a>
    </li>
    <li *ngIf="canSeeReportCategory('Management') | async">
      <a routerLink="/management">Management Reports</a>
    </li>
    <li *ngIf="canSeeReportCategory('Other') | async">
      <a routerLink="/other">Other Reports</a>
    </li>
    <li *ngIf="canSeeReportCategory('PsManagement') | async">
      <a routerLink="/ps-management">Management Reports</a>
    </li>
    <li *ngIf="canSeeReportCategory('PsOperations') | async">
      <a routerLink="/ps-operations">Operations Reports</a>
    </li>
  </ul>
</p-card>

<app-reports-view category="home"></app-reports-view>
